















import { Component, Vue } from 'vue-property-decorator'
import pages from '@/constants/pages'

@Component({})
export default class QuestionButton extends Vue {
  protected askQuestion () {
    this.$store.dispatch('askQuestion')
  }

  protected goToSolve () {
    this.$router.push(pages.SOLVE_PATH)
  }
}
